import { ServiceProvider } from '@quasarcast/vue-service'
import { useAuthState } from 'services/auth/useAuthState'
import makeSqliteStorer from 'services/storage/local/makeSqliteStorer'
import stringSerializer from 'src/shared/serializers/stringSerializer'

let initialTenantId = ''
let initialOrgId = ''

export const authServiceProvider: ServiceProvider = {
  /**
   * Register any services by adding them to app
   */
  register: async () => {
    const tenantIdStorer = makeSqliteStorer('fuellox', 'tenantId', undefined, stringSerializer)
    const orgIdStorer = makeSqliteStorer('fuellox', 'orgId', undefined, stringSerializer)

    initialTenantId = (await tenantIdStorer.get()) ?? ''
    initialOrgId = (await orgIdStorer.get()) ?? ''
  },

  /**
   * Boot is run after all services are registered
   */
  setup: () => {
    const authState = useAuthState()

    if (initialTenantId === 'undefined') initialTenantId = ''
    if (initialOrgId === 'undefined') initialOrgId = ''

    authState.tenantId.value = initialTenantId
    authState.orgId.value = initialOrgId
  },
}
